"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.certificateKindSchema = exports.certificatePublicSchema = exports.certificateSchema = void 0;
const zod_1 = __importDefault(require("zod"));
exports.certificateSchema = zod_1.default.object({
    issuedAt: zod_1.default.coerce.date(),
    displayText: zod_1.default.string(),
});
exports.certificatePublicSchema = zod_1.default.object({
    publicId: zod_1.default.string(),
    issuedAt: zod_1.default.coerce.date(),
    media: zod_1.default.object({
        pdf: zod_1.default.string(),
        portrait: zod_1.default.string(),
        landscape: zod_1.default.string(),
    }),
    displayText: zod_1.default.string(),
});
exports.certificateKindSchema = zod_1.default.enum([
    "conversationPractice",
    "activityUnits",
]);
//# sourceMappingURL=certificate.js.map